import type Paginated from 'app/core/paginable';
import Env from 'env';
import { buildParams } from 'utils/params';

import { headers, HttpAxios, promiseWith } from './httpAxios';

export class HttpApiApplication extends HttpAxios {
  constructor() {
    super({ baseURL: Env.baseUrlApplicationApi, headers: headers });
  }

  async paginate<T = any, R = Paginated<T>>(
    baseUrl: string,
    page: number,
    pageSize: number,
    params: any = undefined
  ): Promise<R> {
    console.log({ baseUrlApplication: baseUrl });

    const newParams = buildParams(params);
    let queryParams = '';
    if (newParams) {
      const searchParams = new URLSearchParams();
      Object.keys(newParams).forEach((key) => {
        if (newParams[key] !== null && newParams[key] !== undefined) {
          searchParams.append(key, String(newParams[key]));
        }
      });
      queryParams = `&${searchParams.toString()}`;
    }
    const response = await this.service.get(
      `${baseUrl}?page=${page}&pageSize=${pageSize}${queryParams}`
    );
    return promiseWith<R>(response.data);
  }
}
export default new HttpApiApplication();
